let appConsts =
{
  TAB_sprite: {major: 99, minor: 85}        //标注
  
}
export default appConsts



// WEBPACK FOOTER //
// ./src/utils/consts.js